var _g, _g2, _path, _path2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 56,
    viewBox: "0 0 50 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 55.786L0.882812 49.366V13.1309L7.3317 6.71094H43.5379L49.9868 13.1309V49.366L43.5379 55.786H7.3317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 49.1039L0.882812 42.6551V6.44885L7.3317 0H43.5379L49.9868 6.44885V42.6551L43.5379 49.1039H7.3317Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 52.4305L0.882812 46.0105V9.7754L7.3317 3.35547H43.5379L49.9868 9.7754V46.0105L43.5379 52.4305H7.3317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3317 49.1039L0.882812 42.6551V6.44885L7.3317 0H43.5379L49.9868 6.44885V42.6551L43.5379 49.1039H7.3317Z",
    fill: "black"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3259 51.966H7.4956C5.09535 49.5658 3.73619 48.2066 1.33594 45.8064V9.9761C3.73619 7.57585 5.09535 6.21666 7.4956 3.81641H43.3259C45.7261 6.21666 47.0853 7.57585 49.4856 9.9761V45.8064C47.0853 48.2066 45.7261 49.5658 43.3259 51.966Z",
    fill: "#404043"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3259 48.6106H7.4956C5.09535 46.2103 3.73619 44.8511 1.33594 42.4509V6.62063C3.73619 4.22038 5.09535 2.86119 7.4956 0.460938H43.3259C45.7261 2.86119 47.0853 4.22038 49.4856 6.62063V42.4509C47.0853 44.8511 45.7261 46.2103 43.3259 48.6106Z",
    fill: "#404043"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3259 48.6145H7.4956C5.09535 46.2142 3.73619 44.855 1.33594 42.4548V6.62454C3.73619 4.22429 5.09535 2.8651 7.4956 0.464844H43.3259C45.7261 2.8651 47.0853 4.22429 49.4856 6.62454V42.4548C47.0853 44.855 45.7261 46.2142 43.3259 48.6145Z",
    fill: "#212121"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.6029 2.22731L44.338 3.96243L47.7504 7.37485V41.7592L44.338 45.1716L42.6029 46.9067H8.21856L5.26887 43.957L3.09997 41.7881V7.40376L5.26887 5.23486L8.21856 2.28517H42.6029M43.3259 0.492188H7.4956C5.09535 2.89244 3.73619 4.25163 1.33594 6.65188V42.4822C3.73619 44.8824 5.09535 46.2416 7.4956 48.6418H43.3259C45.7261 46.2416 47.0853 44.8824 49.4856 42.4822V6.65188C47.0853 4.25163 45.7261 2.89244 43.3259 0.492188Z",
    fill: "black"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8343 1.7318L44.714 3.61151L48.271 7.16849V41.9577L44.714 45.5147L42.8343 47.3944H8.04506L5.3267 44.6761L2.60833 41.9577V7.16849L5.3267 4.45016L8.04506 1.7318H42.8343ZM43.3259 0.488281H7.4956C5.09535 2.88853 3.73619 4.24773 1.33594 6.64798V42.4782C3.73619 44.8785 5.09535 46.2377 7.4956 48.6379H43.3259C45.7261 46.2377 47.0853 44.8785 49.4856 42.4782V6.64798C47.0853 4.24773 45.7261 2.88853 43.3259 0.488281Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.265 29.8086H27.225V31.3286H25.695V29.8086H22.645V31.3286H21.125V34.3786H22.645V35.8986H24.175V37.4286H25.695V38.9486H27.225V37.4286H28.745V35.8986H30.265V34.3786H31.795V31.3286H30.265V29.8086Z",
    fill: "#7C7C7C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4128 20.6602H37.8828V32.8502H39.4128V20.6602Z",
    fill: "#7C7C7C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8872 32.8516H36.3672V35.9016H37.8872V32.8516Z",
    fill: "#7C7C7C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8872 19.1406H36.3672V20.6606H37.8872V19.1406Z",
    fill: "#7C7C7C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3659 35.8984H34.8359V37.4284H36.3659V35.8984Z",
    fill: "#7C7C7C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3659 17.6211H34.8359V19.1411H36.3659V17.6211Z",
    fill: "#7C7C7C"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8325 37.4297H33.3125V38.9497H34.8325V37.4297Z",
    fill: "#7C7C7C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8325 16.0898H33.3125V17.6198H34.8325V16.0898Z",
    fill: "#7C7C7C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3169 38.9492H31.7969V40.4692H33.3169V38.9492Z",
    fill: "#7C7C7C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3169 14.5703H31.7969V16.0903H33.3169V14.5703Z",
    fill: "#7C7C7C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7956 13.0391H30.2656V14.5691H31.7956V13.0391Z",
    fill: "#7C7C7C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7916 40.4688H19.6016V41.9988H31.7916V40.4688Z",
    fill: "#7C7C7C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2666 11.5195H27.2266V13.0395H30.2666V11.5195Z",
    fill: "#7C7C7C"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6919 19.1406H24.1719V25.2306H25.6919V19.1406Z",
    fill: "#7C7C7C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1706 14.5703H22.6406V19.1403H24.1706V14.5703Z",
    fill: "#7C7C7C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M22.645 13.0391H21.125V14.5691H22.645V13.0391Z",
    fill: "#7C7C7C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2281 11.52V10H18.0781V11.52H19.6081V13.04H21.1281V11.52H27.2281Z",
    fill: "#7C7C7C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1716 25.2305H19.6016V26.7605H24.1716V25.2305Z",
    fill: "#7C7C7C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6081 38.9492H18.0781V40.4692H19.6081V38.9492Z",
    fill: "#7C7C7C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6081 23.7109H18.0781V25.2309H19.6081V23.7109Z",
    fill: "#7C7C7C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0712 37.4297H15.0312V38.9497H18.0712V37.4297Z",
    fill: "#7C7C7C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0712 20.6602H16.5512V22.1902H15.0312V23.7102H18.0712V20.6602Z",
    fill: "#7C7C7C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0378 35.8984H13.5078V37.4284H15.0378V35.8984Z",
    fill: "#7C7C7C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0378 23.7109H13.5078V28.2809H15.0378V23.7109Z",
    fill: "#7C7C7C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5044 28.2812H11.9844V35.9012H13.5044V28.2812Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.169b46069ef3cb0c8acae9ae5f190092.svg";
export { ForwardRef as ReactComponent };